module.exports = __webpack_public_path__ + "static/media/bnr1.fc9916a8.jpg";